<template>
  <v-card>
    <v-toolbar
      class="px-4"
      style="
        background: linear-gradient(60deg, #66bb6a, #43a047);
        color: white;
        max-height: 64px;
      "
    >
      <span
        style="
          font-size: 1.125rem;
          line-height: 1.4em;
          font-weight: 300;
          font-size: 18px;
        "
        >@{{ item.entity }}</span
      >
      <v-spacer></v-spacer>
      <md-button
        id="buttonWhite"
        @click="$emit('close-edit-dialog')"
        class="md-simple md-just-icon"
      >
        <md-icon>close</md-icon>
      </md-button>
    </v-toolbar>
    <v-card-text class="pa-0">
      <md-card-content>
        <form class="form-horizontal" action method="post">
          <div class="md-layout containerFlex">
            <div class="textLabel colorDark" style="margin-top: 12px;">
              {{ $t('entityCreate.name') }}
            </div>
            <div class="textLabel colorGrey">
              {{ $t('entityCreate.textName') }}
            </div>
            <md-field style="margin-top: 0;">
              <md-icon>alternate_email</md-icon>
              <md-input
                :disabled="isNotCheckedOut"
                v-model="entity.entity"
                :placeholder="$t('entityCreate.nameLabel')"
              ></md-input>
            </md-field>
            <v-row
              no-gutters
              class="pa-0"
              style="
                margin-top: 20px;
                margin-bottom: 20px;
                width: 100%;
                justify-content: space-between;
              "
            >
              <v-col cols="auto">
                <v-row no-gutters>
                  <v-col cols="auto">
                    <div class="textLabel colorDark" style="margin-top: 20px;">
                      {{$t('editEntityDialog.value')}}
                    </div>
                    <md-field style="width: 300px; margin-right: 20px;">
                      <md-input
                        :disabled="isNotCheckedOut"
                        style="
                          background-color: rgb(244, 244, 244);
                          padding-left: 4px;
                        "
                        v-model="valueToAdd.value"
                        :placeholder="$t('editEntityDialog.enterValueForExampleExtract')"
                      ></md-input>
                    </md-field>
                  </v-col>
                  <v-col cols="auto" style="align-self: flex-end;">
                    <md-field style="width: 100px; margin-right: 20px;">
                      <label>{{$t('editEntityDialog.type')}}</label>
                      <md-select
                        :disabled="isNotCheckedOut"
                        style="
                          background-color: rgb(244, 244, 244);
                          padding-left: 4px;
                        "
                        v-model="valueToAdd.type"
                      >
                        <md-option value="synonyms">{{$t('editEntityDialog.synonym')}}</md-option>
                        <md-option value="pattern">{{$t('editEntityDialog.pattern')}}</md-option>
                      </md-select>
                    </md-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="5" style="align-self: flex-end;">
                <div
                  class="md-layout"
                  style="margin-top: 8px; margin-bottom: 10px;"
                >
                  <div class="md-layout-item" style="margin: auto;">
                    Fuzzy matching
                  </div>
                  <div
                    class="md-layout-item md-form-label md-size-15"
                    style="padding: 0; margin: auto;"
                    :class="{
                      'text-success': entity.fuzzy_match,
                      'text-danger': !entity.fuzzy_match,
                    }"
                  >
                    {{
                      entity.fuzzy_match
                        ? $t('commonWords.enabled')
                        : $t('commonWords.disabled')
                    }}
                  </div>
                  <div class="md-layout-item md-size-15">
                    <md-switch
                      :disabled="isNotCheckedOut"
                      v-model="entity.fuzzy_match"
                    ></md-switch>
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-row no-gutters style="width: 100%;">
              <v-col
                cols="auto"
                v-for="n in contentArr.length + 1"
                :key="n"
                style="align-self: flex-end;"
              >
                <v-row no-gutters style="width: 390px;">
                  <v-col cols="auto" style="align-self: flex-end;">
                    <div
                      v-if="n == 1"
                      class="textLabel colorDark"
                      style="margin-top: 20px;"
                    >
                      {{
                        valueToAdd.type == 'synonyms' ? 'Sinônimo' : 'Padrão'
                      }}
                    </div>
                    <md-field
                      v-if="n == contentArr.length + 1"
                      :id="n"
                      style="
                        margin-right: 20px;
                        margin-bottom: 20px;
                        width: 300px;
                      "
                    >
                      <md-input
                        :disabled="isNotCheckedOut"
                        style="
                          background-color: rgb(244, 244, 244);
                          padding-left: 4px;
                        "
                        @keyup.enter="addContent()"
                        v-model="attAdd"
                        :placeholder="
                          valueToAdd.type == 'synonyms'
                            ? 'Por exemplo: Resumo'
                            : 'Por exemplo: (\\d{3})'
                        "
                      ></md-input>
                    </md-field>
                    <md-field
                      v-else
                      :id="n"
                      style="
                        margin-right: 20px;
                        margin-bottom: 20px;
                        width: 300px;
                      "
                    >
                      <md-input
                        style="
                          background-color: rgb(244, 244, 244);
                          padding-left: 4px;
                        "
                        v-model="contentArr[n - 1]"
                        :placeholder="
                          valueToAdd.type == 'synonyms'
                            ? 'Por exemplo: Resumo'
                            : 'Por exemplo: (\\d{3})'
                        "
                      ></md-input>
                    </md-field>
                  </v-col>
                  <v-col
                    cols="1"
                    style="align-self: flex-end; margin-right: 30px;"
                  >
                    <span
                      v-if="n == contentArr.length + 1"
                      @click="addContent()"
                    >
                      <md-icon
                        v-if="attAdd != ''"
                        style="
                          cursor: pointer;
                          color: blue;
                          margin-bottom: 35px;
                        "
                        >add</md-icon
                      >
                    </span>
                    <span
                      v-else
                      id="removeContent"
                      @click="removeContent(n - 1)"
                    >
                      <md-icon style="cursor: pointer; margin-bottom: 35px;"
                        >horizontal_rule</md-icon
                      >
                    </span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row no-gutters class="pa-0">
              <v-row no-gutters>
                <v-col cols="auto" style="margin-right: 8px;">
                  <md-button
                    :disabled="valueToAdd.value == ''"
                    @click="addValue()"
                    class="md-facebook"
                  >
                    <span>{{$t('editEntityDialog.add')}}</span>
                  </md-button>
                </v-col>
                <v-col v-if="valueToAdd.type == 'synonyms'" cols="auto">
                  <md-button
                    :disabled="valueToAdd.value == ''"
                    class="md-github"
                  >
                    <span>{{$t('editEntityDialog.showRecommendations')}}</span>
                  </md-button>
                </v-col>
              </v-row>
            </v-row>
            <v-row no-gutters class="pa-0">
              <md-table
                :value="queriedData"
                md-card
                :md-selected-value.sync="selected"
                class="table-striped paginated-table"
                style="padding: 12px; overflow: hidden;"
              >
                <md-table-toolbar>
                  <md-field>
                    <label for="pages">{{ $t('intentsList.perPage') }}</label>
                    <md-select v-model="pagination.perPage" name="pages">
                      <md-option
                        v-for="(item, i) in pagination.perPageOptions"
                        :key="i"
                        :label="item"
                        :value="item"
                      >
                        {{ item }}
                      </md-option>
                    </md-select>
                  </md-field>

                  <md-field>
                    <md-input
                      type="search"
                      class="mb-3"
                      clearable
                      style="width: 200px;"
                      :placeholder="$t('intentsList.search') + '...'"
                      v-model="searchQuery"
                    >
                    </md-input>
                  </md-field>
                </md-table-toolbar>

                <md-table-toolbar
                  slot="md-table-alternate-header"
                  slot-scope="{ count }"
                  style="position: relative;"
                >
                  <div class="backgroundRed md-toolbar">
                    <div class="md-toolbar-section-start">
                      {{ count }}
                      {{
                        count > 1
                          ? $t('intentsList.itemsSelected')
                          : $t('intentsList.itemSelected')
                      }}
                    </div>

                    <div class="md-toolbar-section-end">
                      <md-button
                        @click="deleteSelected()"
                        :disabled="isNotCheckedOut"
                        class="md-simple md-github"
                      >
                        <md-icon>delete</md-icon>
                        {{ $t('intentsList.delete') }}
                      </md-button>
                      <md-button
                        @click="clearSelection"
                        class="md-simple md-github"
                      >
                        {{ $t('intentsList.cancel') }}
                      </md-button>
                    </div>
                  </div>
                </md-table-toolbar>

                <md-table-row
                  :class="{ 'disable-click': isNotCheckedOut }"
                  slot="md-table-row"
                  slot-scope="{ item }"
                  md-selectable="multiple"
                >
                  <md-table-cell
                    @click.native="editValue(item)"
                    class="link pointer-cursor"
                    md-label="Exemplo de usuário"
                    md-sort-by="value"
                    >@{{ item.value }}</md-table-cell
                  >
                  <md-table-cell md-label="Tipo">{{ item.type }}</md-table-cell>
                  <md-table-cell md-label="Exemplos">
                    <template v-if="item.type == 'synonyms'">
                      <v-col cols="12">
                        <v-chip-group active-class="primary--text">
                          <v-chip
                            v-for="(singleContent, i) in item.synonyms"
                            :key="i"
                            small
                            >{{ singleContent }}</v-chip
                          >
                        </v-chip-group>
                      </v-col>
                    </template>
                    <template v-else>
                      <v-col cols="12">
                        <v-chip-group active-class="primary--text">
                          <v-chip
                            v-for="(singleContent, i) in item.patterns"
                            :key="i"
                            small
                            >{{ singleContent }}</v-chip
                          >
                        </v-chip-group>
                      </v-col>
                    </template>
                  </md-table-cell>
                </md-table-row>
              </md-table>
              <md-card-actions md-alignment="space-between">
                <div class="">
                  <p class="card-category">
                    {{
                      $t('intentsList.showingItems', {
                        from: from + 1,
                        to: to,
                        total: total,
                      })
                    }}
                  </p>
                </div>
                <pagination
                  class="pagination-no-border pagination-success"
                  v-model="pagination.currentPage"
                  :per-page="pagination.perPage"
                  :total="total"
                >
                </pagination>
              </md-card-actions>
            </v-row>
            <div style="width: 100%;">
              <div
                class="md-layout"
                style="width: 100%; justify-content: flex-end;"
              >
                <md-button
                  :disabled="isNotCheckedOut"
                  @click="$emit('save', entity)"
                  class="md-success"
                >
                  <span>{{$t('editEntityDialog.toSave')}}</span>
                </md-button>
              </div>
            </div>
          </div>
        </form>
      </md-card-content>
    </v-card-text>
    <v-dialog
      v-model="editDialog"
      @click:outsite.stop="editDialog = false"
      max-width="800px"
      :scrollable="true"
    >
      <EditEntityValue
        v-if="editDialog"
        :value="valueToEdit"
        @input="saveValue"
        ref="editEntityValue"
        @cancel="editDialog = false"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import Pagination from '@/components/Pagination.vue'
import EditEntityValue from '@/components/EditEntityValue.vue'
import Fuse from 'fuse.js'
import clonedeep from 'lodash.clonedeep'
export default {
  props: ['item'],
  components: {
    Pagination,
    EditEntityValue
  },
  watch: {
    typeWatch (newValue, oldValue) {
      this.contentArr = []
    },
    searchQuery (value) {
      let result = this.entity.values
      if (value !== '') {
        result = this.fuseSearch.search(this.searchQuery)
      }
      this.searchedData = result
    }
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData () {
      let result = this.entity.values || []
      if (this.searchedData.length > 0) {
        result = this.searchedData
      }
      return result.slice(this.from, this.to)
    },
    to () {
      let highBound = this.from + this.pagination.perPage
      if (this.total < highBound) {
        highBound = this.total
      }
      return highBound
    },
    from () {
      return this.pagination.perPage * (this.pagination.currentPage - 1)
    },
    total () {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.entity.values.length
    },
    typeWatch () {
      return this.valueToAdd.type
    },
    isNotCheckedOut () {
      return !this.$store.getters['snapshots/userCanEdit']
    }
  },
  data () {
    return {
      selected: [],
      entity: {},
      editDialog: false,
      valueToEdit: {},
      valueToAdd: {
        value: '',
        type: 'synonyms',
        synonyms: []
      },
      currentSort: 'value',
      currentSortOrder: 'asc',
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: '',
      propsToSearch: ['value'],
      searchedData: [],
      fuseSearch: null,
      attAdd: '',
      contentArr: [],
      example: ''
    }
  },
  methods: {
    clearSelection () {
      this.selected = []
    },
    customSort (value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort
        if (this.currentSortOrder === 'desc') {
          return a[sortBy].localeCompare(b[sortBy])
        }
        return b[sortBy].localeCompare(a[sortBy])
      })
    },
    deleteSelected () {
      this.entity.values = this.entity.values.filter(
        (value) => !this.selected.includes(value)
      )
      this.clearSelection()
    },
    deleteRow (item) {
      let indexToDelete = this.entity.values.findIndex(
        (tableRow) => tableRow.id === item.id
      )
      if (indexToDelete >= 0) {
        this.entity.values.splice(indexToDelete, 1)
      }
    },
    addValue () {
      if (this.valueToAdd.type === 'synonyms') {
        this.valueToAdd.synonyms = this.contentArr
      } else {
        this.valueToAdd.patterns = this.contentArr
      }
      this.entity.values.push(this.valueToAdd)
      this.contentArr = []
      this.attAdd = ''
      this.valueToAdd = {
        value: '',
        type: 'synonyms',
        synonyms: []
      }
    },
    editValue (value) {
      this.valueToEdit = value
      this.editDialog = true
    },
    saveValue (value) {
      this.$set(this.valueToEdit, 'value', value.value)
      this.$set(this.valueToEdit, 'type', value.type)
      if (value.type === 'synonyms') {
        this.$set(this.valueToEdit, 'synonyms', value.synonyms)
      } else {
        this.$set(this.valueToEdit, 'patterns', value.patterns)
      }
      // console.log('saveValue', this.valueToEdit)
      this.editDialog = false
    },
    addContent () {
      if (this.attAdd !== '') {
        this.contentArr.push(this.attAdd)
        this.attAdd = ''
      }
    },
    removeContent (index) {
      this.contentArr.splice(index, 1)
    }
  },
  beforeMount () {
    this.entity = clonedeep(this.item)
    this.fuseSearch = new Fuse(this.entity.values, {
      keys: ['value'],
      threshold: 0.3
    })
  }
}
</script>

<style>
.pointer-cursor {
  cursor: pointer;
}
.v-toolbar__content > .md-button.md-simple i {
  color: white !important;
}
.md-field.md-theme-default:not(.md-focused) > .md-icon {
  color: rgba(0, 0, 0, 0.6) !important;
}
#removeContent > .md-icon.md-theme-default.md-icon-font {
  color: rgba(0, 0, 0, 0.6) !important;
}
.textLabel {
  width: 100%;
  font-size: 14px;
  line-height: 24px;
}
.colorDark {
  color: #393939;
}
.colorGrey {
  color: rgba(111, 111, 111, 0.603);
}
.backgroundRed {
  background-color: rgba(255, 82, 82, 0.2) !important;
  border-radius: 0px !important;
  box-shadow: none !important;
  color: rgba(0, 0, 0, 0.87) !important;
  width: 100%;
  height: 56px;
  position: absolute;
  top: 0;
}
.backgroundRed:hover {
  color: rgba(0, 0, 0, 0.87) !important;
}
.inlineTitle {
  display: inline-block;
}
.rightJustify {
  position: absolute;
  right: 4px;
}
.disable-click {
  pointer-events: none;
}

.link {
  cursor: pointer;
  color: blue;
}

.link:hover {
  text-decoration: underline;
}
</style>
